import { render, staticRenderFns } from "./PropertyStatus.vue?vue&type=template&id=4fbce4a2&scoped=true&"
import script from "./PropertyStatus.vue?vue&type=script&lang=js&"
export * from "./PropertyStatus.vue?vue&type=script&lang=js&"
import style0 from "./PropertyStatus.vue?vue&type=style&index=0&id=4fbce4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbce4a2",
  null
  
)

export default component.exports